import { AbstractContentState, useCmsContent } from '@cp-shared-15/frontend-integration';
import { GenericErrorPage } from 'cpie-common';
import { fetchGenericError } from './GenericErrorPageSlice';
import { GenericErrorPageContentSelector } from './GenericErrorPageContentSelector';

export function useGenericErrorPage(): AbstractContentState<GenericErrorPage> {
    return useCmsContent(fetchGenericError, GenericErrorPageContentSelector);
}
